interface TenantInfo {
  tenantName: string;
  tenantEmail: string;
}

interface TenantStatusIndicatorProps {
  tenant: TenantInfo | undefined;
}

/**
 * Reusable TenantStatusIndicator component
 * Single responsibility: Show active tenant status and notification info
 */
export function TenantStatusIndicator({ tenant }: TenantStatusIndicatorProps) {
  return (
    <div className="bg-muted/50 border rounded-lg p-4">
      <div className="flex items-center gap-2">
        {tenant ? (
          <>
            <div className="h-2 w-2 rounded-full bg-green-500" />
            <span className="text-sm font-medium">
              Active Tenant: {tenant.tenantName}
            </span>
          </>
        ) : (
          <>
            <div className="h-2 w-2 rounded-full bg-gray-400" />
            <span className="text-sm text-muted-foreground">
              No active tenant - Notification will not be sent
            </span>
          </>
        )}
      </div>
      {tenant && (
        <p className="text-xs text-muted-foreground mt-1 ml-4">
          {tenant.tenantEmail} will be notified about this maintenance request
        </p>
      )}
    </div>
  );
}
